import React from 'react'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { BRAND_STORE } from 'store'
import { PageWrapper as PageWrapperUI } from '@touche-lts/panel-ui/dist'

const PageWrapper = props => {
  const { children } = props
  const {
    match: { path }
  } = children.props

  const applyMargin = [
    '/editor/shots/:id',
    '/editor/timeline-tags/:id'
  ].includes(path)
  return (
    <PageWrapperUI style={applyMargin ? { marginLeft: 10 } : {}}>
      {children}
    </PageWrapperUI>
  )
}

export default inject(BRAND_STORE)(observer(PageWrapper))
